import type { ComposerTranslation } from 'vue-i18n'

/** 与 `/logmanage/alert-history/list` 列表行一致 */
export type WarningLogRowLike = {
  alert_msg?: string
  template_id?: string | number
  variables?: string
  opt_data?: string | Record<string, unknown>
}

function parseVariables(raw: unknown): Record<string, string | number> {
  if (raw == null || raw === '') return {}
  try {
    const obj = typeof raw === 'string' ? (JSON.parse(raw) as unknown) : raw
    if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
      const out: Record<string, string | number> = {}
      for (const [k, v] of Object.entries(obj as Record<string, unknown>)) {
        if (v == null) continue
        if (typeof v === 'string' || typeof v === 'number') {
          out[k] = v
        } else if (typeof v === 'boolean') {
          out[k] = v ? 1 : 0
        } else {
          out[k] = JSON.stringify(v)
        }
      }
      return out
    }
  } catch {
    // ignore
  }
  return {}
}

export function resolveWarningLogTemplateId(row: WarningLogRowLike): string | null {
  const raw = row.template_id
  if (raw === null || raw === undefined) return null
  const s = String(raw).trim()
  if (!/^\d+$/.test(s)) return null
  const n = Number(s)
  if (!Number.isFinite(n) || n < 1 || n > 11) return null
  return s
}

export function warningLogDisplayText(
  t: ComposerTranslation,
  te: (key: string) => boolean,
  row: WarningLogRowLike,
): string {
  const typeKey = resolveWarningLogTemplateId(row)
  const params = parseVariables(row.variables ?? row.opt_data)
  if (typeKey) {
    const i18nKey = `noticeManage.warningLogActions.${typeKey}`
    if (te(i18nKey)) {
      try {
        return String(t(i18nKey, params as Record<string, unknown>))
      } catch {
        return String(t(i18nKey))
      }
    }
  }
  const msg = row.alert_msg
  if (msg != null && String(msg).trim() !== '') return String(msg)
  return '--'
}
